import { Box } from "@mui/material";
import { Progression } from "components/events/judging/pending/usePendingLeaderboard";
import { CutLine } from "components/layout/series/rankings/CutLine";
import { useTranslate } from "components/providers/LocalizationProvider";
import { Sx } from "utils/sx";

const cutLineStyles: Sx = (theme) => ({
    borderColor: theme.palette.error.main,
    borderStyle: "solid",
    borderWidth: theme.spacing(0, 0.25),
});

export const ProgressionCutLine: React.FC<{
    progression: Progression;
    index: number;
    tied?: boolean;
}> = ({ progression, index, tied }) => {
    const cutLineIndex = progression.findIndex(progression => index === progression.position);
    const isFirstCutLine = cutLineIndex === 0;
    const description = useTranslate(isFirstCutLine ? "TOP" : "NEXT");

    if (cutLineIndex === -1) return null;

    const cutLine = progression[cutLineIndex];
    const cutLineDescription = `${description} ${cutLine.max}`;

    return <Box component="li" sx={tied ? cutLineStyles : undefined}><CutLine description={cutLineDescription} tableRow={false} /></Box>;
};
